import { makeStyles } from "@tiny/components";

export const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    flexDirection: "column",
    marginBottom: 16,
  },
  top: {
    display: "flex",
    alignItems: "center",
    gap: 8,
    marginBottom: 12,
  },
  check: {
    flex: "0 0 32px",
    display: "flex",
    alignItems: "center",
  },
  search: {
    flex: 1,
  },
  searchField: {
    [theme.breakpoints.up("md")]: {
      width: 270,
    },
  },
  selected: {
    flex: 1,
    display: "flex",
    alignItems: "center",
  },
  deleteButton: {
    marginRight: 8,
  },
  mergeButton: {
    marginRight: 8,
  },
  audienceSummaryButton: {
    marginRight: 8,
    wordBreak: "keep-all",
  },
  actions: {
    display: "flex",
    alignItems: "center",
    flexWrap: "wrap" as const,
    gap: 4,
    paddingTop: 12,
    [theme.breakpoints.up("md")]: {
      paddingLeft: 40,
    },
  },
  sort: {
    display: "flex",
    gap: 10,
    [theme.breakpoints.up("md")]: {
      width: 196,
    },
  },
  divider: {
    marginLeft: theme.spacing(-5),
    marginRight: theme.spacing(-5),
    [theme.breakpoints.up("md")]: {
      marginLeft: theme.spacing(-6),
      marginRight: theme.spacing(-6),
    },
  },
  bottom: {},
}));
